import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/consultant/logo.png';
import _imports_1 from '@/assets/img/consultant/qr.jpg';
import _imports_2 from '@/assets/img/consultant/close.png';
import _imports_3 from '@/assets/img/home/service.png';
const _withScopeId = n => (_pushScopeId("data-v-21742a42"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "avatar"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "头像",
  width: "80",
  height: "80"
})]), /*#__PURE__*/_createElementVNode("div", null, "Hi,我是您的专属增长顾问"), /*#__PURE__*/_createElementVNode("div", null, "为500+品牌提供数智营销解决方案")], -1));
const _hoisted_4 = {
  class: "bottom"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "212",
  height: "212",
  class: "qr"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "scan"
}, /*#__PURE__*/_toDisplayString('<<立即扫码 抢先咨询>>'), -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "phone"
}, "联系电话：18640148662", -1));
const _hoisted_8 = {
  class: "close"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "客服",
  class: "service"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'Slider',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const active = ref(-1);
    const visible = ref(true);
    const items = [{
      img: require('@/assets/img/home/phone.png'),
      activeImg: require('@/assets/img/home/phone_a.png'),
      text: '联系我们'
    }, {
      img: require('@/assets/img/home/consult.png'),
      activeImg: require('@/assets/img/home/consult_a.png'),
      text: '扫码咨询'
    }, {
      img: require('@/assets/img/home/free.png'),
      activeImg: require('@/assets/img/home/free_a.png'),
      text: '免费试用'
    }];
    const enter = i => {
      if (i === 2) return active.value = i;
      change(i);
    };
    const change = i => {
      if (i === 0) {
        if (globalThis.matchMedia('(max-width: 767PX)').matches) {
          let a = document.createElement('a');
          a.href = 'tel:18640148662';
          a.click();
          a = null;
        } else {
          active.value = i;
        }
      } else if (i === 1) {
        active.value = i;
      } else {
        active.value = i;
        router.push({
          name: 'login'
        });
        active.value = -1;
      }
    };
    const clickAway = () => {
      active.value = -1;
    };
    return (_ctx, _cache) => {
      const _directive_click_away = _resolveDirective("click-away");
      return _unref(route).name !== 'login' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [visible.value ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "slider",
        onMouseleave: _cache[2] || (_cache[2] = $event => active.value = -1)
      }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _hoisted_7, _createElementVNode("div", {
        class: "free",
        onClick: _cache[0] || (_cache[0] = $event => change(2))
      }, "免费定制数智营销方案")])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        src: _imports_2,
        alt: "关闭",
        width: "30",
        height: "30",
        onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
      })])], 32)), [[_directive_click_away, clickAway]]) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "item",
        onClick: _cache[3] || (_cache[3] = $event => visible.value = true)
      }, _hoisted_10))])) : _createCommentVNode("", true);
    };
  }
});